import { loanExceptionCategoryOptions } from '../Exceptions.constants';

export const getSubCategoryOptions = (subCategories, category) =>
  (subCategories || [])
    .filter(item => !category || item.category === category)
    .map(item => ({ value: item.id, label: item.name }));

export const buildInitialFormState = ({ exception, subCategories }) => {
  const categoryOption =
    loanExceptionCategoryOptions.find(({ value }) => value === exception?.category) || null;

  const subCategoryOption =
    getSubCategoryOptions(subCategories, exception?.category).find(
      ({ value }) => value === exception?.subCategoryId,
    ) || null;

  return {
    category: categoryOption,
    subCategory: subCategoryOption,
    subject: exception?.subject || '',
    justification: exception?.justification || '',
    hmdaImpact: !!exception?.hmdaImpact,
  };
};
